import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const usePredicateStoreUpdatePredicate = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const updatePredicate = useStore(store, (s) => s.updatePredicate);

    return updatePredicate;
};
